import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="44" viewBox="0 0 66 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0H66V44H0" fill="#8A1538" />
    <path
      d="M18.48 44H0V0H18.48L25.52 2.44444L18.48 4.88889L25.52 7.33333L18.48 9.77778L25.52 12.2222L18.48 14.6667L25.52 17.1111L18.48 19.5556L25.52 22L18.48 24.4444L25.52 26.8889L18.48 29.3333L25.52 31.7778L18.48 34.2222L25.52 36.6667L18.48 39.1111L25.52 41.5556L18.48 44Z"
      fill="white"
    />
    <path d="M0 44V1.14648e-07H66V44H0ZM0.825 43.0833H65.175V0.916665H0.825V43.0833Z" fill="#9F9D9D" />
  </svg>
)
